import { PhoneCall, MessageCircle, Mail } from "lucide-react";
import { AZIENDA } from "@/lib/config";

export const MobileBar = () => (
  <div style={{ paddingBottom: "calc(0.5rem + env(safe-area-inset-bottom))" }} className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-3 gap-2 p-2 bg-white/95 backdrop-blur border-t border-slate-200" data-testid="mobile-contact-bar">
    <a href={AZIENDA.telefonoLink} className="flex flex-col items-center justify-center rounded-xl bg-orange-600 text-white py-2 text-xs font-bold" data-testid="mobile-call-btn">
      <PhoneCall className="w-5 h-5" /> Chiama H24
    </a>
    <a href={AZIENDA.whatsappLink} target="_blank" rel="noreferrer" className="flex flex-col items-center justify-center rounded-xl bg-green-600 text-white py-2 text-xs font-bold" data-testid="mobile-whatsapp-btn">
      <MessageCircle className="w-5 h-5" /> WhatsApp
    </a>
    <a href={AZIENDA.emailLink} className="flex flex-col items-center justify-center rounded-xl bg-sky-600 text-white py-2 text-xs font-bold" data-testid="mobile-email-btn">
      <Mail className="w-5 h-5" /> Email
    </a>
  </div>
);
